import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-medis-subtle px-6">
          <div className="text-center max-w-md">
            <div className="font-display text-2xl font-bold text-medis-navy">Something went wrong</div>
            <p className="mt-3 text-medis-gray text-sm">Please reload the page to continue.</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-6 bg-medis-blue text-white px-6 py-3 rounded-md text-sm font-semibold"
              data-testid="error-reload-button"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
